import { render } from "./RangeShortcuts.vue?vue&type=template&id=2f9dc106&scoped=true&bindings={\"modelValue\":\"props\",\"color\":\"props\",\"dark\":\"props\",\"dateTime\":\"props\",\"customShortcuts\":\"props\",\"height\":\"props\",\"computedTypes\":\"data\",\"selectedShortcut\":\"data\",\"init\":\"options\",\"noticeDeprecation\":\"options\",\"getShortcutByKey\":\"options\",\"select\":\"options\"}"
import script from "./RangeShortcuts.vue?vue&type=script&lang=js"
export * from "./RangeShortcuts.vue?vue&type=script&lang=js"

import "./RangeShortcuts.vue?vue&type=style&index=0&id=2f9dc106&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f9dc106"

export default script